<template>
  <div>
    <h3 class="text-white text-lg font-semibold mb-4">Links Rápidos</h3>
    <ul class="space-y-2">
      <li v-for="link in links" :key="link.href">
        <a href="#" @click.prevent="handleClick(link.href)" class="hover:text-white transition-colors">
          {{ link.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

const links = [
  { href: '#agents', text: 'Agentes' },
  { href: '#pricing', text: 'Preços' },
  { href: '#faq', text: 'FAQ' }
]

function handleClick(href: string) {
  const targetId = href.replace('#', '')

  if (router.currentRoute.value.path !== '/') {
    router.push({ path: '/', hash: href }).then(() => {
      setTimeout(() => {
        history.replaceState(null, '', '/')
      }, 500) //
    })
  } else {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>